"use client";

import { FC, PropsWithChildren, useContext, useMemo } from "react";
import { MultiViewProvider, useSiteConfig } from "@finbackoffice/site-core";
import { usePathnameWithLocal } from "hooks";
import Sidebar from "components/side-bar/Sidebar";
import { ISiteConfigLayouts } from "@finbackoffice/fe-core";
import SubHeader from "components/sub-header/SubHeader";
import Header from "components/header/Header";
import dynamic from "next/dynamic";
import { RouteNames } from "utils/constants";
import { usePathname } from "next/navigation";
import { BetSlipItemsContext } from "contexts";
import styles from "./tablet-layout.module.sass";

const BetSlip = dynamic(() => import("components/sport/betslip/BetSlip"), {
    ssr: false,
});

function BetSlipWrapper() {
    const { betItems } = useContext(BetSlipItemsContext);
    const pathname = usePathname();
    const { pathnameValues } = usePathnameWithLocal();

    const showBetSlip = useMemo(() => {
        const isSport =
            pathname.includes(`${RouteNames.SPORT}/${RouteNames.LIVE}`) ||
            pathname.includes(`${RouteNames.SPORT}/${RouteNames.PREMATCH}`) ||
            pathname.includes(`${RouteNames.SPORT}/${RouteNames.UPCOMING}`) ||
            pathname.includes(`${RouteNames.SPORT}/${RouteNames.RESULTS}`) ||
            pathname.includes(`${RouteNames.SPORT}/${RouteNames.CALENDAR}`) ||
            pathname.includes(`${RouteNames.SPORT}/${RouteNames.MULTI_VIEW}`);
        const isHome = pathnameValues.length === 0;

        return isSport || (isHome && betItems.length > 0);
    }, [betItems.length, pathname, pathnameValues.length]);

    if (!showBetSlip) {
        return null;
    }

    return (
        <section className={styles.block}>
            <BetSlip />
        </section>
    );
}

const TabletLayout: FC<PropsWithChildren> = ({ children }) => {
    const siteLayoutsConfig = useSiteConfig<ISiteConfigLayouts>("layouts");

    return (
        <MultiViewProvider>
            <section className={styles.container}>
                <Sidebar />
                <Header layout="tablet" />
                {siteLayoutsConfig.subHeader.enable && <SubHeader />}
                {children}
                <BetSlipWrapper />
            </section>
        </MultiViewProvider>
    );
};

export default TabletLayout;
